<template>
<div>
  <div class="meter-order-fee-item-annotation">
    <div class="search-wrap">
      <el-button size="mini" @click="open()">创建模板</el-button>
      <el-button size="mini" @click="pageChange(1)">查询</el-button>
    </div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表类型">
          <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="仪表类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="费项名称">
          <el-input size="mini" placeholder="费项名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <el-table show-summary v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" >
        <!--      <el-table-column type="selection" width="55"></el-table-column>-->
        <el-table-column prop="id" label="id" width="80"></el-table-column>
        <el-table-column prop="name" label="费项名称 " width="200"></el-table-column>
        <el-table-column label="仪表类型" width="100">
          <template slot-scope="scope">
            {{listToidByName(meter_type_list,scope.row.meter_type)}}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            {{listToidByName(status_list,scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间 "  width="140"></el-table-column>

        <el-table-column prop="update_time" label="修改时间" width="140"></el-table-column>

        <el-table-column label="操作 " width="280">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="open(scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px;text-align: center;margin-right: 20px;">
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>

    <MeterFeeTagEditor ref="MeterFeeTagEditorRef" />

    <!--  <ApportionTemplateWin ref="ApportionTemplateWinRef" />-->
    <SelectMeterTree ref="SelectMeterTreeRef" />
  </div>
</div>
</template>

<script>
import SelectMeterTree from "./components/SelectMeterTree";
import MeterFeeTagEditor from "../meter_fee_tag/components/MeterFeeTagEditor";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterOrderFeeItemAnnotation",
  inject:['mainObj','componentId','setComponentId'],
  components:{MeterFeeTagEditor, SelectMeterTree},
  data() {
    return{
      where:{
        name:"",
        meter_type:""
      },
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
      meter_type_list:[],
      status_list:[{id:0,name:'停用'},{id:1,name:'启用'}]
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.pageChange(1)
  },
  methods:{
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterOrderFeeTag/getList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
     })
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    open(id=null){
      const that=this;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目')
        return false;
      }
      that.$refs.MeterFeeTagEditorRef.show({
        project_id:that.mainObj.project_id,
        id:id
      },()=>{
        that.pageChange(1);
      })
    },
    copyApportionTemplateWin(item){
      const that=this;
      that.$refs.SelectMeterTreeRef.show({
        title:"",
        project_id:that.mainObj.project_id,
        isCheckbox:true,
      },meter_list=>{
        //children_count
        if(meter_list.length>0){
          let text=`此操作将设置 ${meter_list.length} 个仪表的分摊对象配置, 是否继续?`;
          that.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let meter_ids=meter_list.filter(ret=>(ret.check_Child_State===ret.children_count||ret.check_Child_State===-1)).map(ret=>ret.id);
            that.setMeterApportion(item.id,meter_ids)
          });
        }else {
          that.$message.error('请选择仪表')
        }
      });
    },
    setMeterApportion(template_id=0,meter_ids=[]){
      const that = this;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterOrderFeeTag/setMeterApportion",{
        project_id:that.mainObj.project_id,
        template_id:template_id,
        meter_ids:JSON.stringify(meter_ids),
        user_type:(that.$route.query.type||0),
      },res=>{
        if (res.code) {
          that.$message.success('设置成功')
        }else {
          that.$message.error(res.msg||'设置失败')
        }
      });
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    listToidByName(list,id){
      let index=list.findIndex(ret=>ret.id==id)
      return list[index].name
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.meter-order-fee-item-annotation{

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderFeeItemAnnotation.vue